import { CARD_STATS, CAREER_EXTRA_STATS, MISSING_STAT } from '../constants'
import type { CareerHighlight, StatColumn, StatsRole } from '../types'
import { getGamesPlayedAbbr } from './statValues'

/**
 * The career totals for the Career row, read from the career row. First the
 * ones worth a glance — games played, then the role's card stats — then up to
 * `CAREER_EXTRA_STATS` more in the season table's column order. Stats the sport
 * doesn't track are skipped, so soccer leads MP · G · A and hockey GP · G · A
 * · P; an extra without a career value (`–`, e.g. GFA) is left out.
 */
export const buildCareerHighlights = (
  columns: StatColumn[],
  careerRow: Record<string, string>,
  role: StatsRole
): CareerHighlight[] => {
  const abbrs = columns.map((c) => c.abbr)
  if (abbrs.length === 0) {
    return []
  }
  const toHighlight = (column: StatColumn): CareerHighlight => ({
    abbr: column.abbr,
    name: column.name,
    value: careerRow[column.abbr],
  })
  const lead = [getGamesPlayedAbbr(abbrs), ...CARD_STATS[role]].flatMap(
    (abbr) => columns.filter((c) => c.abbr === abbr)
  )
  const extras = columns
    .filter(
      (c) =>
        !lead.includes(c) &&
        careerRow[c.abbr] !== undefined &&
        careerRow[c.abbr] !== MISSING_STAT
    )
    .slice(0, CAREER_EXTRA_STATS)
  return [...lead, ...extras].map(toHighlight)
}
